import { Component, OnInit, Inject, ComponentFactoryResolver } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogHost } from '../dialog-host';
import { Subject } from 'rxjs';
import { LogService } from 'src/app/log.service';

@Component({
  selector: 'file360-modal-dialog-standard',
  templateUrl: './modal-dialog-standard.component.html',
  styleUrls: ['./modal-dialog-standard.component.scss']
})
export class ModalDialogStandardComponent extends DialogHost implements OnInit {

  /**
   * Title of the dialog
   */
  title: string = "";

  /**
   * Text displayed in the primary button
   */
  primary: string = "";

  /**
   * Text displayed in the secondary button
   */
  secondary: string = "";

  /**
   * Emits event when primary button clicked.
   */
  private onPrimary: Subject<void>;

  /**
   * Emits event when secondary button clicked.
   */
  private onSecondary: Subject<void>;

  /**
   * Style the content of this component differently whether the content has its own header or not.
   */
  contentSuppliesHeader: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, protected componentFactoryResolver: ComponentFactoryResolver, protected logService: LogService) {
    super(data, componentFactoryResolver, logService);
    this.title = data.title;
    this.primary = data.primary;
    this.secondary = data.secondary
    this.onPrimary = data.onPrimary;
    this.onSecondary = data.onSecondary;
    this.contentSuppliesHeader = data.data.contentSuppliesHeader;
  }

  ngOnInit() {
    this.createComponent();

    //
    // For programmatic invocation if these events,
    // subscribe to the action events and invoke the correct action
    //
    if (this.dialogChild != undefined) {
      if (this.dialogChild.onPrimary != undefined) {
        this.dialogChild.onPrimary.subscribe(() => this.primaryClick());
      }
      if (this.dialogChild.onSecondary != undefined) {
        this.dialogChild.onSecondary.subscribe(() => this.secondaryClick());
      }
    }
  }

  /**
   * Fire the primary event
   */
  primaryClick() {

    this.logService.logMessage(`modal-dialog-standard; primaryClick()`);
    //
    // Send the dialog's data to the event's subscriber.
    //
    if (this.dialogChild != undefined) {
      this.onPrimary.next(this.dialogChild.data);
    } else {
      this.onPrimary.next();
    }
  }

  /**
   * Fire the secondary event
   */
  secondaryClick() {
    this.logService.logMessage(`modal-dialog-standard; secondaryClick()`);


    this.onSecondary.next();
  }
}
